module.exports = __webpack_public_path__ + "assets/src/style/img/svg/icons/category-art-performance.svg?dd3911d3772c0383713697e62dd98e7a";